import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { uploadVideo } from '@/services/videoApi';
import type { VideoUploadResponse } from '@/types/api';

interface UseVideoUploadOptions {
  videoType?: 'template' | 'athlete';
  onSuccess?: (data: VideoUploadResponse) => void;
  onError?: (error: Error) => void;
}

export function useVideoUpload(options?: UseVideoUploadOptions) {
  const [uploadProgress, setUploadProgress] = useState(0);
  const queryClient = useQueryClient();
  const videoType = options?.videoType ?? 'athlete';

  const mutation = useMutation({
    mutationFn: (file: File) => uploadVideo(file, videoType, setUploadProgress),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['videos'] });
      setUploadProgress(0);
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      setUploadProgress(0);
      options?.onError?.(error);
    },
  });

  return {
    upload: mutation.mutate,
    uploadAsync: mutation.mutateAsync,
    isUploading: mutation.isPending,
    uploadProgress,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
}
